export default "__VITE_ASSET__DqF5bGpm__"